import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { toast } from "sonner";

import { api } from "../App";
import PageHeader from "../components/PageHeader";
import LookupForm from "./lookup/LookupForm";
import LookupResultCard from "./lookup/LookupResultCard";
import LookupEmptyState from "./lookup/LookupEmptyState";

function toastForStatus(status, message) {
  if (status === "FOUND") {
    toast.success("Parcel found");
    return;
  }
  if (status === "NOT_FOUND") {
    toast.warning("Parcel not found in DEP PDF");
    return;
  }
  if (status === "ERROR") {
    toast.error(message || "Lookup failed");
    return;
  }
  toast.info(message || status);
}

export default function LookupPage() {
  const [parcelId, setParcelId] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const onSearch = async (e) => {
    e?.preventDefault();
    const clean = (parcelId || "").trim();
    if (!clean) {
      toast.error("Enter a parcel (folio) number");
      return;
    }
    setLoading(true);
    try {
      const res = await api.post("/lookup", { parcel_id: clean });
      setResult(res.data);
      toastForStatus(res.data.status, res.data.message);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Lookup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 sm:p-8 md:p-12 max-w-7xl mx-auto w-full">
      <PageHeader
        eyebrow="Collier County"
        title="Wetland determination lookup"
        subtitle="Enter a parcel (folio) number. We pull the latest PDF straight from the Florida DEP, pick the correct range, and tell you what it says."
      />

      <LookupForm
        parcelId={parcelId}
        setParcelId={setParcelId}
        loading={loading}
        onSubmit={onSearch}
      />

      <AnimatePresence mode="wait">
        {result && <LookupResultCard result={result} />}
      </AnimatePresence>

      {!result && <LookupEmptyState />}
    </div>
  );
}
